<template>
    <div id="home">
        <banner-cmp></banner-cmp>
        <car-model-cmp></car-model-cmp>

        <promotion-cmp></promotion-cmp>
        <model-photos-cmp></model-photos-cmp>

        <latest-news-cmp></latest-news-cmp>
        <contact-us-cmp></contact-us-cmp>



        
    </div>
</template>

<script>
import bannerCmp from '../components/home/banner-cmp.vue';
import CarModelCmp from '@/components/home/car-model-cmp.vue';
import PromotionVidCmp from '@/components/home/promotion-vid-cmp.vue';
import ModelPhotosCmp from '@/components/home/model-photos-cmp.vue';
import LatestNewsCmp from '@/components/home/latest-news-cmp.vue';
import ContactUsCmp from '@/components/home/contact-us-cmp.vue';
export default {
    data() {
        return {
            
        };
    },
    methods: {
        
    },
    components: {
        'banner-cmp': bannerCmp,
        'car-model-cmp': CarModelCmp,
        'promotion-cmp': PromotionVidCmp,
        'model-photos-cmp': ModelPhotosCmp,
        'latest-news-cmp': LatestNewsCmp,
        'contact-us-cmp': ContactUsCmp,
    },
    mounted() {
        
    },
};
</script>
